<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.projectCode }}</label>
          </div>
          <div class="form-group col-sm-8">
            {{ record.code  }}
        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.date }}</label>
          </div>
          <div class="form-group col-sm-8">
            {{ record.date_doc }}
        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.type }}</label>
          </div>
          <div class="form-group col-sm-8">

            {{ record.type }}

        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.topic }}</label>
          </div>
          <div class="form-group col-sm-8">
            {{ record.title }}

        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.description }}</label>
          </div>
          <div class="form-group col-sm-8">
            {{ record.desp }}
            
          </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.addresser }}</label>
          </div>
          <div class="form-group col-sm-8">

            {{ record.add1 }}

        </div>
      </div>



      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.addressee }}</label>
          </div>
          <div class="form-group col-sm-8">

            {{ record.add2 }}

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang.attachments }}</label>
          </div>
          <div class="form-group col-sm-8">

            <div *ngFor='let attach of record.attachments.split(",")'>
              <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/project/{{attach}}"
                target="_blank">{{attach}}</a>
            </div>

        </div>
      </div>


    </div>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ generalLang.close }}</button>

  </div>
</form>
